export default __webpack_public_path__ + "static/media/OpenSans-Regular.9ccd5e1b.ttf";